import { CommonLaboratoryDatasource } from '@/shared/resources/datasources/common/common-laboratory-datasource'
import { ShipmentRequestResponse } from '@/modules/shipments-module/services/shipments.dto'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { AgColumnDefinition, IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { shipmentsRequestFiltererService } from '@/modules/shipments-module/services/request/request-filterer/shipments-request-filterer.service'
import { shipmentsGridPendingToSendColumnDefs } from '@/modules/shipments-module/components/grid/column-defs/shipments-grid-pending-to-send.column-defs'

export class ShipmentsGridPendingToSendDatasource extends CommonLaboratoryDatasource<ShipmentRequestResponse> {
    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<ShipmentRequestResponse>> {
        return shipmentsRequestFiltererService.findPendingToBeSend(this.laboratoryId, filterModel, params)
    }

    public getColumnDefs(): AgColumnDefinition[] {
        return shipmentsGridPendingToSendColumnDefs
    }
}
